<div class="feed-item" *ngIf="isTeacher && classroom?.visit_info?.is_author">
  <app-feed-post-form (posted)="onContentPosted()" [classroomId]="classroom.id"></app-feed-post-form>
</div>

<ng-template ngFor let-item [ngForOf]="content.items" let-i="index" [ngForTrackBy]="trackContentByFn">
  <app-content-card [item]="item" [inline]="true" [cut]="true"></app-content-card>
</ng-template>

<ng-container *ngIf="content.items.length === 0 && content.loaded">
  <app-no-content-stub
    [icon]="'no-content-icon'"
    [text]="noPublicationsMessage">
  </app-no-content-stub>
</ng-container>

<app-pagination
  [enabled]="content.loaded"
  [loading]="content.loading"
  [pagination]="content.pagination"
  [nothingMoreText]="''"
  baseUrl=""
  (nextPage)="nextPage()">
</app-pagination>
